import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Drawer } from "@material-ui/core";

import { useScreen, useSearchLinks } from "hooks";

import useStyles from "./useStyles";
import SideMenu from "./components/SideMenu";
import MobileHeader from "./components/MobileHeader";
import DesktopHeader from "./components/DesktopHeader";

const Header = () => {
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { getSearchLinks, searchLinks } = useSearchLinks();

  const [isDrawerOpened, setDrawerOpened] = useState(false);

  const handleDrawerOpen = () => setDrawerOpened(true);
  const handleDrawerClose = () => setDrawerOpened(false);

  useEffect(() => {
    getSearchLinks();
  }, []);

  return (
    <>
      <AppBar position="fixed" color="transparent" classes={{ root: classes.root }}>
        <Toolbar disableGutters classes={{ root: classes.toolbar }}>
          {isDesktop ? (
            <DesktopHeader onDrawerOpen={handleDrawerOpen} searchLinks={searchLinks} />
          ) : (
            <MobileHeader onDrawerOpen={handleDrawerOpen} searchLinks={searchLinks} />
          )}
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={isDrawerOpened} onClose={handleDrawerClose}>
        <SideMenu onClose={handleDrawerClose} searchLinks={searchLinks} />
      </Drawer>
    </>
  );
};

export default Header;
